export const LABELS = {
  TITLE: 'Group is missing',
  SUBTITLE:
    'To apply for a property, your application needs have a group, a group lets us know who are applying with you. You can be in a group with just yourself or with friends and family.',
  BUTTON: 'Resolve',
};
